<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
          <div class="content-page-header">
            <h5>
              <a @click="$router.go(-1)" style="color: #28084b">
                <i class="feather feather-arrow-left me-1"></i> </a
              >Pricing
            </h5>
          </div>
        </div>
        <!-- /Page Header -->

        <div class="d-flex justify-content-center align-items-center">
          <p class="fs-6">Monthly</p>
          <div class="toggle-switch">
            <input
              type="checkbox"
              v-model="checkBox"
              class="toggle-checkbox"
              id="toggle"
            />
            <label class="toggle-label" for="toggle"></label>
          </div>
          <p class="fs-6">Yearly</p>
        </div>

        <!-- Price Table -->
        <div class="price-table-main">
          <div class="row">
            <div
              class="col-lg-4 col-md-12"
              v-for="plan in filtered_plans"
              :key="plan.id"
            >
              <div class="card">
                <div class="card-body">
                  <div class="price-dollar mt-4">
                    <h1
                      style="font-size: 28px"
                      class="d-flex align-items-center"
                    >
                      {{
                        settings === "NGN"
                          ? useCurrency(plan.amount_ngn)
                          : useCurrency(plan.amount_usd)
                      }}
                      <span class="ms-1"
                        >/{{
                          plan.duration === 1
                            ? "mo"
                            : plan.duration === 12
                            ? "yr"
                            : plan.duration
                        }}</span
                      >
                    </h1>
                  </div>
                  <div class="plan-header">
                    <!-- <span class="plan-widget-icon">
                      <img src="@/assets/img/icons/plan-price-01.svg" alt="" />
                    </span> -->
                    <div class="plan-title ms-0">
                      <h4 class="plan-name">{{ plan?.name }}</h4>
                    </div>
                  </div>

                  <div class="plan-description">
                    <h6>What’s included</h6>
                    <ul>
                      <li
                        v-for="feature in plan.restrictions"
                        :key="feature.id"
                      >
                        <template v-if="feature.id !== 12">
                          <span
                            v-if="feature.value !== false"
                            class="rounded-circle bg-success-light me-2"
                            ><i class="feather feather-check"></i
                          ></span>
                          <span
                            v-else
                            class="rounded-circle bg-danger-light me-2"
                            ><i class="feather feather-x"></i
                          ></span>
                          <p class="text-capitalize">
                            {{ feature.name }}
                          </p>
                        </template>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="plan-button"
                    v-if="plan?.name != active_subscription?.name"
                  >
                    <button
                      :disabled="plan.id === selectedID && isLoading"
                      @click="openPaymentModal(plan.id)"
                      class="w-100 btn btn-primary py-3 d-flex align-items-center justify-content-center"
                    >
                      <span
                        v-if="plan.id === selectedID && isLoading"
                        class="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                      ></span>

                      <span v-if="plan.id === selectedID && isLoading"
                        >Processing...</span
                      >
                      <span v-else
                        >Subscribe<span class="ms-2"
                          ><i class="feather feather-arrow-right"></i
                        ></span>
                      </span>
                    </button>
                  </div>
                  <div class="plan-button" v-else>
                    <button
                      class="btn w-100 btn-white d-flex align-items-center justify-content-center"
                    >
                      Active<span class="ms-2"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Price Table -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- Payment Modal -->
  <div class="modal custom-fade fade" id="payment_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <form @submit.prevent="makePayment" class="modal-body">
          <div class="form-header">
            <h3>Make Payment</h3>
            <div class="form-group text-start mt-2">
              <label for="currencyLabel">Gateway</label>

              <b-form-select class="form-select" v-model="gateway" required>
                <b-form-select-option selected value=""
                  >Please select</b-form-select-option
                >
                <b-form-select-option
                  v-for="(gateway, index) in allGateway"
                  :key="index"
                  :value="gateway.value"
                >
                  {{ gateway.name }}
                </b-form-select-option>
              </b-form-select>
            </div>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <button
                  type="submit"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Make Payment</span>
                  <span v-if="isLoading">Processing...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  @click="closePaymentModal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Payment Modal -->
  <!-- /Main Wrapper -->
</template>
<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useCurrency } from "@/assets/composables/currency";
import { Modal } from "bootstrap";

const isLoading = ref(false);
const store = useStore();
const selectedID = ref(null);
const duration = ref(1);
const checkBox = ref(false);
const paymentModal = ref(null);

const allGateway = [
  { name: "Stripe", value: "stripe" },
  { name: "Paypal", value: "paypal" },
];

const gateway = ref("");

const filtered_plans = computed(() => {
  if (checkBox.value === true) {
    return filterPlans((duration.value = 12));
  } else {
    return filterPlans((duration.value = 1));
  }
});

const settings = computed(() => {
  return store.getters["settings/settings"]?.currency;
});
const plan = computed(() => {
  return store.getters["plan/plans"].filter((plan) => plan.name === "Basic");
});
const filterPlans = (value) => {
  return store.getters["plan/plans"].filter((plan) => value === plan.duration);
};
const active_subscription = computed(() => {
  return store.getters["plan/active_subscription"].plan;
});



const getPlans = () => {
  store.dispatch("plan/getPlans");
};
const getActivePlan = () => {
  store.dispatch("plan/getActiveSubscription");
};

const paymentlink = computed(() => {
  return store.getters["plan/paystacklink"];
});

const plan_id = ref(null);
const openPaymentModal = (id) => {
  plan_id.value = id;
  if (settings.value === "NGN") {
    makePayment();
  } else {
    paymentModal.value.show();
  }
};
const closePaymentModal = () => {
  paymentModal.value.hide();
  gateway.value = "";
};

const makePayment = async () => {
  selectedID.value = plan_id.value;
  let data = null;
  if (settings.value === "NGN") {
    data = {
      plan_id: plan_id.value,
      gateway: "paystack",
    };
  } else {
    data = {
      plan_id: plan_id.value,
      gateway: gateway.value,
    };
  }
  isLoading.value = true;
  await store
    .dispatch("plan/makePayment", data)
    .then(() => {
      isLoading.value = false;
      if (paymentlink.value !== null) {
        window.location.href = paymentlink.value;
      }
      if (settings.value !== "NGN") {
        closePaymentModal();
      }
    })
    .catch(() => {
      isLoading.value = false;
      if (settings.value !== "NGN") {
        closePaymentModal();
      }
    });
};

onMounted(() => {
  getPlans();
  getActivePlan();

  paymentModal.value = new Modal(document.getElementById("payment_modal"), {
    backdrop: "static",
    keyboard: false,
  });
});
</script>

<style scoped>
.toggle-switch {
  position: relative;
  width: 60px;
  height: 30px;
  margin: 0 10px;
}

.toggle-checkbox {
  display: none;
}

.toggle-label {
  position: absolute;
  top: 0;
  left: 0;
  width: 55px;
  height: 28px;
  background-color: #fff;
  border-radius: 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.toggle-checkbox:checked + .toggle-label {
  background-color: #fff;
}

.toggle-label::before {
  content: "";
  position: absolute;
  width: 24px;
  height: 24px;
  background-color: #3865b0;
  border-radius: 50%;
  left: 5px;
  right: 5px;
  top: 2px;
  transition: transform 0.3s;
}

.toggle-checkbox:checked + .toggle-label::before {
  transform: translateX(22px);
  background-color: #3865b0;
}
</style>
